<template>
<div class="chapter">
<div class="inner_page">
<h2 class="p_heading_1" id="auto_bookmark_1"><span class="calibre1">Erstes Buch: Über die Natur des Krieges</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0010.vue?1bd10c48